// extracted by mini-css-extract-plugin
export default {"notice":"ContingencyDeadlineReviewNotice_notice__TvQKn","icon":"ContingencyDeadlineReviewNotice_icon__N4JLF","text":"ContingencyDeadlineReviewNotice_text__4MBvJ"};